const $scrollUp = $('.js-scrollUp')

if ($scrollUp.length > 0) {
  $scrollUp.on('click', () => {
    $('body, html').animate({
      scrollTop: 0,
    })
  })

  $(window).on('load resize scroll', () => {
    const scrolled = $(window).scrollTop()
    const vh = $(window).height()

    if (scrolled > vh) {
      $scrollUp.addClass('is_visible')
    } else {
      $scrollUp.removeClass('is_visible')
    }
  })
}
